//src->api.js
import axios from "axios";

// const baseURL = "http://localhost:8000/api";
// const baseURL = "http://147.93.20.58:8000/api";
// const baseURL = "http://lms.aipreneur.in:8000/api";
// const baseURL = "https://147.93.20.58/api";

// const baseURL = "https://lms.aipreneur.in/api";
const baseURL = "https://api.quantumrealty.co.in/api";
// const baseURL = "http://46.202.166.184:8000/api";

// Create an Axios instance with base settings
const api = axios.create({
  baseURL: baseURL, // Set your API endpoint here
  timeout: 10000, // Optional: Timeout for requests
  // httpsAgent: new (require('https').Agent)({
  //   rejectUnauthorized: false, // Bypass SSL certificate validation
  // }),
});

// Add request and response interceptors (optional)
api.interceptors.request.use(
  (config) => {
    // Add authorization headers or other configurations here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

// Common function for POST requests
export const postRequest = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data);
    return response.data; // Return only the response data
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong!");
  }
};

// Specific API for login
export const login = async (email, password) => {
  return postRequest("/login", { email, password });
};

// GET API for fetching dashboard data
export const fetchDashboardData = async () => {
  try {
    const response = await api.get("/dashboard");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch dashboard data."
    );
  }
};
export const fetchBlogsData = async () => {
  try {
    const response = await api.get("/blogs"); // Replace "/blogs" with your actual endpoint
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch blogs data."
    );
  }
};

// POST API for updating dashboard data (with multipart form data)
export const updateDashboardData = async (formData) => {
  try {
    const response = await api.post("/dashboard", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update dashboard data."
    );
  }
};

export const fetchBlogs = async () => {
  try {
    const response = await api.get("/blogs");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};

export const getAboutOverview = async () => {
  try {
    const response = await api.get("/aboutOverview");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const getQuantamHistory = async () => {
  try {
    const response = await api.get("/quantamHistory");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchClientPageAPI = async () => {
  try {
    const response = await api.get("/client-page");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchSocialResponsibility = async () => {
  try {
    const response = await api.get("/social");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch social responsibility data.");
  }
};
export const fetchClients = async () => {
  try {
    const response = await api.get("/clients");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
/** Load catalogue for public UI (Insight project listing needs all rows client-side filtered). Server paginates unless a high limit is requested. */
export const fetchProjectsAPI = async (params = { page: 1, limit: 10000 }) => {
  try {
    const response = await api.get("/projects", { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchBlogById = async ({ id }) => {
  try {
    const response = await api.post("/blogs/blogsById", { id });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};

export const fetchOurServices = async () => {
  try {
    const response = await api.get("/ourService");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchInvesterService = async () => {
  try {
    const response = await api.get("/investerService");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchDeveloperService = async () => {
  try {
    const response = await api.get("/developerService");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};

export const fetchOtherService = async () => {
  try {
    const response = await api.get("/otherService");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};

export const fetchOurPeople = async () => {
  try {
    const response = await api.get("/ourPeople");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchJobs = async () => {
  try {
    const response = await api.get("/jobs");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const fetchJobById = async (id) => {
  try {
    const response = await api.get(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch job.");
  }
};

export const submitJobApplication = async (formData) => {
  try {
    const response = await api.post("/job-applicants", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to submit application."
    );
  }
};

export const FetcherServicesMasters = async () => {
  try {
    const response = await api.get("/ourServicesMasters");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};
export const FetchOurOtherServiceByType = async (type) => {
  try {
    const response = await api.get(`/ourOtherService/${type}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs.");
  }
};

export const fetchCareers = async () => {
  try {
    const response = await api.get("/careers");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch careers.");
  }
};

export const fetchCareerImages = async () => {
  try {
    const response = await api.get("/career-images");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch career images.");
  }
};

export const fetchOurVoices = async () => {
  try {
    const response = await api.get("/ourVoices");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch our voices.");
  }
};

export const fetchOurPresence = async () => {
  try {
    const response = await api.get("/ourPresence");
    const data = response.data;
    console.log("[fetchOurPresence] raw response.data:", Array.isArray(data) ? "array" : typeof data, "length/keys:", Array.isArray(data) ? data.length : data ? Object.keys(data) : "null");
    let result = [];
    if (Array.isArray(data)) result = data;
    else if (Array.isArray(data?.data)) result = data.data;
    else if (Array.isArray(data?.results)) result = data.results;
    console.log("[fetchOurPresence] returning array length:", result.length, "titles:", result.map((i) => i?.title));
    return result;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch our presence.");
  }
};

export const fetchAboutOurPeople = async () => {
  try {
    const response = await api.get("/aboutOurPeople");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch about our people.");
  }
};

export const fetchContactDetails = async () => {
  try {
    const response = await api.get("/contactDetails/");
    const data = response.data;
    return Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch contact details.");
  }
};

export const fetchOurOffices = async () => {
  try {
    const response = await api.get("/our-offices/");
    const data = response.data;
    return Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch our offices.");
  }
};

/** Unified case-insensitive search (jobs, projects, people, locations) */
export const fetchGlobalSearch = async (query, limit = 3) => {
  const q = String(query ?? "").trim();
  if (!q) {
    return {
      query: "",
      jobs: [],
      projects: [],
      people: [],
      locations: [],
    };
  }
  try {
    const response = await api.get("/search", { params: { q, limit } });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || error.response?.data?.message || "Search failed."
    );
  }
};

export default api;
